import React from 'react';

/*
 * The chrome of a form field: its label above, and one line underneath for the
 * hint or the error.
 *
 * Lifted from the seller wizard's `FormField`, whose three declarations are
 * copied by hand into `ZoneFormModal`, `AddressFields` and `ManualOrderForm`.
 * Those keep their copies and move to this in a later pass.
 */

/** The standard text input of the platform, in both themes. */
export const inputClass =
  'w-full bg-ninja-gray/50 dark:bg-[#111] border border-border rounded-xl px-4 py-2.5 text-sm text-ninja-dark dark:text-white outline-none focus:border-ninja-green transition-colors disabled:opacity-60 disabled:cursor-not-allowed';

export const labelClass = 'block text-sm font-semibold text-ninja-dark dark:text-white mb-1.5';

/**
 * @param {object} props
 * @param {string} props.label
 * @param {string} [props.htmlFor] - The id of the control, so the label names it.
 * @param {string} [props.error]
 * @param {React.ReactNode} [props.hint] - Shown only while there is no error to show.
 * @param {React.ReactNode} props.children - The control itself.
 */
export const Field = ({ label, htmlFor, error, hint, children }) => (
  <div>
    <label htmlFor={htmlFor} className={labelClass}>
      {label}
    </label>
    {children}
    {error ? (
      <p className="text-danger text-xs mt-1">{error}</p>
    ) : (
      hint && <p className="text-text-muted text-xs mt-1">{hint}</p>
    )}
  </div>
);
